import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderPage } from "../../../components/layouts/PlaceholderPage";
import { requireModuleAccess, MODULE_FLEET_MANAGEMENT } from "../../../lib/auth/route-protection";
import { useI18n } from "../../../lib/i18n";

function FleetProgramsPage() {
  const { t } = useI18n();
  return <PlaceholderPage title={t("pro.fleet.programsTitle")} />;
}

export const Route = createFileRoute("/fleet/programs/")({
  beforeLoad: requireModuleAccess(MODULE_FLEET_MANAGEMENT),
  component: FleetProgramsPage,
});
